import { WidgetTourAction, WidgetTourActionHandler } from '../models'

class WidgetTourActionRegistry {
  private readonly handlers = new Map<string, WidgetTourActionHandler>()

  register(widgetId: string, handler: WidgetTourActionHandler): () => void {
    this.handlers.set(widgetId, handler)

    return () => {
      if (this.handlers.get(widgetId) === handler) {
        this.handlers.delete(widgetId)
      }
    }
  }

  async execute(widgetId: string, action: WidgetTourAction): Promise<boolean> {
    const handler = this.handlers.get(widgetId)

    if (!handler) {
      return false
    }

    return (await handler(action)) !== false
  }
}

export const widgetTourActionRegistry = new WidgetTourActionRegistry()
